import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()

pinia.use(piniaPluginPersistedstate)

pinia.use(({ store }) => {
    store.$onAction(({ name, args, after, onError }) => {
        // only do this in dev
        if (process.env.NODE_ENV === 'development') {
            after((result) => {
                console.log(`Action "${name}" completed with result:`, result);
            });

            onError((error) => {
                console.error(`Action "${name}" failed with error:`, error);
            });
        }
    })
})

export default pinia
